import './UploadPreview.css'
import UploadPreview from './UploadPreview'

export default UploadPreview
